export const HeartIconFilled = (props: { className?: string }) => {
    return (
        <svg
            className={`HeartIconFilled ${props.className}`}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.7421 3.42185C19.5928 2.48688 18.1524 1.98395 16.6709 2.00039C15.1894 2.01683 13.7604 2.5516 12.6321 3.51185C12.6153 3.53273 12.5939 3.54957 12.5697 3.56114C12.5455 3.57271 12.519 3.57871 12.4921 3.57871C12.4653 3.57871 12.4388 3.57271 12.4146 3.56114C12.3903 3.54957 12.369 3.53273 12.3521 3.51185C11.2239 2.5516 9.79491 2.01683 8.31342 2.00039C6.83192 1.98395 5.39146 2.48688 4.24214 3.42185C1.72214 5.65185 1.35214 9.18185 3.00214 12.8918C4.22214 15.4018 11.1221 21.1618 12.0021 21.8118C12.1348 21.9167 12.2941 21.9825 12.4621 22.0018C12.6521 22.0018 12.7421 21.9118 12.9321 21.9118C13.2121 21.6318 20.3921 15.9618 21.9321 12.9918C23.7321 9.36185 23.2621 5.74185 20.7421 3.42185Z"
                fill="#C4C4C4"
            />
        </svg>
    );
};
